import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
// import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ConnectionService } from '../../connection.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { trc20_abi } from '../../contracts/trc20_abi'
import { type } from 'os';
import { dummyContractabi } from '../../contracts/user_contract'
import { filter } from 'rxjs/operators';
import { TabsetComponent, TabDirective } from 'ngx-bootstrap/tabs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-rewardsec',
  templateUrl: './rewardsec.component.html',
  styleUrls: ['./rewardsec.component.css']
})
export class RewardsecComponent implements OnInit {
  @ViewChild('claimForm') claimForm: TemplateRef<any>;
  // modalRef: BsModalRef;
  // @ViewChild('feeForm') feeForm: TemplateRef<any>;
  @ViewChild('editor') editor;
  text: string = "";

  pageColor = localStorage.getItem('dark-Theme')

  accHeader: any
  token = localStorage.getItem('Sastana_Token'); signLoader = false; SrPro: any = {}; nextRound: any; url;
  result: any;
  userdata: any = {}
  qtd: any = {};
  input: any = {}
  @ViewChild('readForm') readForm: TemplateRef<any>;
  userAddress = localStorage.getItem('Address')
  finalResult: any = {
  }
  details: any = {};
  response: any;
  writeMethods: any;
  allowanceResult: any;
  contractAddress: any;
  contractName: any;
  conabibyte: any = {};
  transactionList: any;
  expandView: any = false
  expandView1: any = false
  contract_abi: any
  writeResult: any;
  contarctTab: any;
  isContract: any = false
  isToken: any = true
  feeObj: any = {}
  activeTab: number = 0;
  creatorObj: any = {};
  topContracts: any;
  topcontractMethods: any;
  contractAbi: any;
  result1: any;
  finalResult1: any = {};
  resultLength: any;
  solversion: any;
  solFile: any = [];
  readResult: any;
  loadingItem: any
  inputvalues: any = {}
  solSingle: string;
  payablewriteResult: any;
  conParams: any;
  isDisabled: boolean = false;
  writeMethodInputs: any;
  addressType: any;
  Isaddress: any;
  writeStatus: any;
  feeStatus: any;
  assetValue: any;

  constructor(private modalService: NgbModal, private conn: ConnectionService, private alert: ToastrService, private route: Router, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.contractAddress = this.activatedRoute.snapshot.params['address']
    this.contractName = this.activatedRoute.snapshot.params['name']
    this.contract_abi = localStorage.getItem('sastana-ABI')
    this.transactionHistory();
    this.getContractBalance();
    this.getContractABIByte();
    this.getContractDetails();
    this.topAddresses();
    this.topMethods();
    this.route.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateActiveTab(event.url);
      });

    setTimeout(() => {
      this.getReadAbi();
      this.getWriteAbi();
    }, 2000)
  }

  open(content: TemplateRef<any>, name: any, type: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {
        if (result == 'confirm' && type == 'nonpayable') {
          this.writeMethodss(name)
        }
        else if (result == 'confirm' && type == 'payable') {
          this.payablewriteMethodss(name)
        }
      },
    );
  }

  updateActiveTab(url: string): void {
    if (url.includes('contract-methods')) {
      this.activeTab = 1;
    } else {
      this.activeTab = 0;
    }
  }

  getEnergy(name?: any) {
    this.conn.postUrl('user_contract/energybandwidthestimate', { address: this.userAddress, contract: this.contractAddress, method: name }).subscribe((res: any) => {
      if (res.status == true) {
        this.feeObj = res.data
      }
    })
  }

  getContractBalance() {
    this.conn.postUrl('wallet/getcontractBalance', { address: this.contractAddress }).subscribe((res: any) => {
      if (res.status == true) {
        this.assetValue = res.data
      }
    })

  }

  getContractABIByte() {
    this.conn.postUrl('user_contract/getContractAbi', { address: this.contractAddress }).subscribe((res: any) => {
      if (res.success == true) {
        this.conabibyte = res.data
        this.conParams = res.data?.constructorParams[0]
        this.contractAbi = res.data.abi,
          this.solversion = res.data.version
        if (typeof (res.data.confile) == 'string') {
          this.solSingle = res.data.confile;
        }
        else {
          this.solFile = res.data.confile;
        }
      }
    })
  }
  getContractDetails() {
    this.conn.postUrl('user_contract/getContractInfo', { address: this.contractAddress }).subscribe((res: any) => {
      if (res.success == true) {
        this.creatorObj = res.data
      }
    })
  }

  topAddresses() {
    this.conn.postUrl('users/topContractAddress', { contract: this.contractAddress }).subscribe((res: any) => {
      this.topContracts = res.data
    })
  }

  topMethods() {
    this.conn.postUrl('users/topContractMethod', { contract: this.contractAddress }).subscribe((res: any) => {
      this.topcontractMethods = res.data
    })
  }

  transactionHistory() {
    this.conn.postUrl('contract/getContracttransByaddress', { contract: this.contractAddress }).subscribe((res: any) => {
      this.transactionList = res.data
    })
  }

  getwrite(name) {
    this.details.address = this.userAddress
    this.details.method = name
    this.details.contract = this.contractAddress
    this.signLoader = true
    this.loadingItem = name

    this.conn.postUrl('user_contract/getWriteQuery', this.details).
      subscribe((result: any) => {
        this.signLoader = false
        this.response = result.data.result
        this.finalResult1[result.data.methodName] = this.response
        this.resultLength = this.finalResult1[result.data.methodName].length
      })
  }

  readMethod(name) {
    this.details.address = this.userAddress
    this.details.method = name
    this.details.contract = this.contractAddress

    const myPostBody = { values: this.inputvalues, details: this.details }
    this.conn.postUrl('user_contract/getReadInputMethods',
      myPostBody,
    ).
      subscribe((result: any) => {
        if (result.status == true) {
          this.inputvalues = {}
          this.readResult = result.data.readResponse
          this.finalResult[result.data.methodName] = this.readResult
        }
        else {
          this.alert.error(result.msg);
        }
      })
  }

  payablewriteMethodss(name) {
    this.signLoader = true
    this.loadingItem = name
    this.details.address = this.userAddress
    this.details.method = name
    this.details.contract = this.contractAddress
    const myPostBody = { values: this.inputvalues, details: this.details }
    this.conn.postUrl('user_contract/getpayableWriteMethods',
      myPostBody,
    ).
      subscribe((result: any) => {
        if (result.status == true) {
          this.signLoader = false
          this.inputvalues = {};
          this.writeStatus = true
          this.payablewriteResult = result.data.transactionHash
          this.finalResult1[result.data.methodName] = this.payablewriteResult
          window.location.reload()

        }
        else {
          this.signLoader = false
          this.writeStatus = false
          this.payablewriteResult = result.message
          this.finalResult1[result.data.methodName] = this.payablewriteResult
        }
      })
  }

  isObjectEmpty(obj: any, method: any): boolean {
    this.writeMethodInputs = this.writeMethods.filter(item =>
      (item.name == method)
    );
    if (Object.keys(obj)?.length != this.writeMethodInputs[0].inputs.length) {
      return true;
    }
    else {
      return false
    }
  }

  isPayableObjectEmpty(obj: any, method: any): boolean {
    this.writeMethodInputs = this.writeMethods.filter(item =>
      (item.name == method)
    );
    if (this.writeMethodInputs[0].stateMutability == 'payable' && Object.keys(obj)?.length == 0) {
      return true;
    }
    else {
      return false
    }
  }

  writeMethodss(name) {
    this.signLoader = true
    this.loadingItem = name
    this.details.address = this.userAddress
    this.details.method = name
    this.details.contract = this.contractAddress
    const myPostBody = { values: this.inputvalues, details: this.details }
    this.conn.postUrl('user_contract/getWriteMethods',
      myPostBody,
    ).
      subscribe((result: any) => {
        if (result.status == true) {
          this.signLoader = false
          this.inputvalues = {}
          this.writeStatus = true
          this.writeResult = result.data.transactionHash
          this.finalResult1[result.data.methodName] = this.writeResult
          window.location.reload()
        }
        else {
          this.signLoader = false
          this.writeStatus = false
          this.writeResult = result.message
          this.finalResult1[result.data.methodName] = this.writeResult
        }
      })

  }

  getRead(name) {
    this.details.address = this.userAddress
    this.details.method = name
    this.details.contract = this.contractAddress
    this.conn.postUrl('user_contract/getReadMethods', this.details).
      subscribe((result: any) => {
        this.response = result.data.result
        this.finalResult[result.data.methodName] = this.response
      })
  }

  async getReadAbi() {
    this.result = await this.contractAbi?.filter(item => {
      return (item.type == 'function' && item.stateMutability == 'view' || item.stateMutability == 'pure')
    })
  }

  async getWriteAbi() {
    this.writeMethods = await this.contractAbi?.filter(item =>
      (item.type == 'function' && (item.stateMutability == "nonpayable" || item.stateMutability == "payable")) && item.type !== "constructor"
    );
  }

  validateAddress() {
    this.conn.postUrl('user_contract/validateAddress', { address: this.inputvalues._numberSumContractAddress }).
      subscribe((result: any) => {
        this.addressType = result.data.type
      })
  }

  preventNonNumericalDotInput(evt: any) {
    if ((evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) && evt.which != 46) {
      evt.preventDefault();
    }
  }

  preventNumericalDotInput(evt: any) {
    if (!(evt.which == 32) &&
      !(evt.which > 64 && evt.which < 91) &&
      !(evt.which > 96 && evt.which < 123)) {
      evt.preventDefault();
    }
  }

  preventCharDotInput(evt: any) {
    if (!(evt.which == 32) &&
      !(evt.which > 47 && evt.which < 58) &&
      !(evt.which > 64 && evt.which < 91) &&
      !(evt.which > 96 && evt.which < 123)) {
      evt.preventDefault();
    }
  }

  validateIsaddress(data: any) {
    this.conn.postUrl('user_contract/isAddress', { address: data }).subscribe((response: any) => {
      this.Isaddress = response.address
    })
  }

  copyArrayText(val: string) {
    let value = JSON.stringify(val, null, 2);
    var result = value.replace(/\\r\\n/g, " ");
    let selBox = document.createElement('textarea');
    selBox.value = result;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }
}